// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "user".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { appointmentColorValues, countryCodeValues, employmentTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "user" table (1:1 with a DB row, on the wire). */
export const userAtomSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    emailVerified: z.boolean(),
    image: z.string().nullable(),
    currency: z.string().nullable(),
    timezone: z.string().nullable(),
    role: z.string().nullable(),
    banned: z.boolean().nullable(),
    banReason: z.string().nullable(),
    banExpires: z.number().nullable(),
    twoFactorEnabled: z.boolean().nullable(),
    mustChangePassword: z.boolean(),
    organizationId: z.string().nullable(),
    orgRole: z.string().nullable(),
    termsAcceptedAt: z.string().datetime().nullable(),
    isStaff: z.boolean(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phone: z.string().nullable(),
    phoneSecondary: z.string().nullable(),
    phoneCountry: z.string().nullable(),
    country: z.enum(countryCodeValues).nullable(),
    bio: z.string().nullable(),
    title: z.string().nullable(),
    headline: z.string().nullable(),
    dateOfBirth: z.string().nullable(),
    employmentStartDate: z.string().nullable(),
    employmentEndDate: z.string().nullable(),
    employmentType: z.enum(employmentTypeValues).nullable(),
    teamMemberRef: z.string().nullable(),
    notes: z.string().nullable(),
    acceptsBookings: z.boolean(),
    languages: z.array(z.string()).nullable(),
    socialLinks: z.unknown().nullable(),
    color: z.enum(appointmentColorValues).nullable(),
    isActive: z.boolean(),
    invitationPending: z.boolean(),
    profileSetupCompleted: z.boolean(),
    calendarAccountId: z.string().nullable(),
    bookingAccountId: z.string().nullable(),
    externalBookingId: z.string().nullable(),
    bookingLink: z.string().nullable(),
    deletedAt: z.string().datetime().nullable(),
    privacyErasedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=user.js.map